import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import {TranslatePipe} from "@ngx-translate/core";
import {DataTableComponent} from "@components/data-table/data-table.component";

@Component({
  selector: 'app-user-role-detail-dialog',
  templateUrl: './user-role-detail-dialog.html',
  standalone: true,
  imports: [
    TranslatePipe,
    DataTableComponent
  ],
  styleUrls: ['./user-role-detail-dialog.css']
})
export class UserRoleDetailDialog implements OnInit {
  role!: string; 
  users: any[] = []; 
  loading: boolean = false;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) {}

  ngOnInit(): void {
    this.users = this.config.data.users;
    this.role = this.config.data.role;
  }


  closeDialog(): void {
    this.ref.close(); // Close the dialog
  }
}
